import LocalStorageKey from '@enums/LocalStorageKey';
import LocalStorageService from '@services/LocalStorageService';

const URL_PARAM = 'promoter';

/**
 * Reads the `promoter` query param from the current URL and persists it
 * in localStorage so it survives navigation within the app.
 * Should be called once on app startup.
 */
export function capturePromoterCode(): void {
  const params = new URLSearchParams(window.location.search);
  const promoter = params.get(URL_PARAM);
  if (promoter) {
    LocalStorageService.setItem(LocalStorageKey.PROMOTER_CODE, promoter);
  }
}

export function getPromoterCode(): string | null {
  return LocalStorageService.getItem<string>(LocalStorageKey.PROMOTER_CODE);
}

export function clearPromoterCode(): void {
  LocalStorageService.removeItem(LocalStorageKey.PROMOTER_CODE);
}
